<script lang="ts">
  import Reference from './Reference.svelte'

  let { data } = $props()
</script>

<h2 class="@heading +large">Help center</h2>

<p class=" @paragraph +xlarge +fill">
  Please choose a section from the menu, or select one of your popular help
  posts. If you can't find what you're looking for, don't hesitate to contact us
  through our customer chat support.
</p>

{#each data.popularPosts as post (post.full_slug)}
  <Reference supheading="Popular" {post} />
{/each}
